/**
 * PWA Debug Helper
 * Helps diagnose PWA installation issues
 */

export function debugPWA(): void {
  console.log('🔍 PWA Debug Information:');
  console.log('---');

  // Check HTTPS
  console.log('✓ Protocol:', window.location.protocol);

  // Check Service Worker support
  console.log('✓ Service Worker supported:', 'serviceWorker' in navigator);

  // Check if running as installed PWA
  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches ||
    (navigator as any).standalone === true;
  console.log('✓ Running as PWA:', isStandalone);

  // Check manifest
  const manifestLink = document.querySelector('link[rel="manifest"]');
  console.log('✓ Manifest link found:', !!manifestLink);
  if (manifestLink) {
    console.log('  Manifest href:', manifestLink.getAttribute('href'));
  }

  // Check icons
  const icons = document.querySelectorAll('link[rel*="icon"]');
  console.log('✓ Icons found:', icons.length);
  icons.forEach((icon, i) => {
    console.log(`  Icon ${i + 1}:`, icon.getAttribute('href'));
  });

  // Check if service worker is registered
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      console.log('✓ Service Worker registrations:', registrations.length);
      registrations.forEach((reg, i) => {
        console.log(`  SW ${i + 1}:`, reg.scope);
        console.log(`    Active:`, !!reg.active);
        console.log(`    Installing:`, !!reg.installing);
        console.log(`    Waiting:`, !!reg.waiting);
      });
    });
  }

  // Check if beforeinstallprompt will fire
  console.log('✓ beforeinstallprompt supported:', 'onbeforeinstallprompt' in window);

  console.log('---');
  console.log('💡 To manually check PWA status:');
  console.log('   Chrome DevTools → Application → Manifest');
  console.log('   Chrome DevTools → Application → Service Workers');
}

// Auto-run on load in dev mode
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - import.meta.env is provided by Vite
if (import.meta.env?.DEV) {
  setTimeout(debugPWA, 1000);
}
